/*
 * author xuhao
 * 封装公共导出组件
 * time 2017/8/1
*/
import myHttp from "./myHttp";
import noDataDialog from "./noDataDialog";

const myXuhaoPlugin = {
	install: function(Vue){

		Vue.component(noDataDialog.name,noDataDialog);

		Vue.mixin(myHttp);
	}
}

export default myXuhaoPlugin;


// WEBPACK FOOTER //
// ./src/myMixin/index.js